import * as React from 'react';

import type { PromoTemplateCannedCollectionFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import MerchandisingBucketsModuleRenderer from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucketsModuleRenderer';
import PromoBannerModuleRenderer from 'bundles/front-page/redesign-modules/promo-banner/PromoBannerModuleRenderer';
import PromoUnitsDelegator from 'bundles/front-page/redesign-modules/promo-units/PromoUnitsDelegator';

type Props = {
  content?: PromoTemplateCannedCollectionFragment;
};

const FrontPageCannedCollectionRendererDelegator = ({ content }: Props) => {
  const items = content?.cardsCollection?.items?.filter(Boolean) ?? [];
  const isBucketStyle = items.length === 3;

  if (!content) return null;

  if (items.length === 1) {
    return <PromoBannerModuleRenderer content={content} />;
  }

  if (isBucketStyle) {
    return <MerchandisingBucketsModuleRenderer content={content} />;
  }

  return <PromoUnitsDelegator content={content} />;
};

export default FrontPageCannedCollectionRendererDelegator;
